import { render, staticRenderFns } from "./InformativeHighlightsFullscreen.vue?vue&type=template&id=1b44ea69&"
import script from "./InformativeHighlightsFullscreen.vue?vue&type=script&lang=js&"
export * from "./InformativeHighlightsFullscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports